import { render, staticRenderFns } from "./SuppliersListTable.vue?vue&type=template&id=4949cd50&"
import script from "./SuppliersListTable.vue?vue&type=script&lang=js&"
export * from "./SuppliersListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports